import React, { useState, useEffect } from "react";
import { Info, X } from "lucide-react";

export default function MaintenanceBanner() {
  const [visible, setVisible] = useState(false);
  const NOTICE_KEY = "weddly_maint_notice_20261014";

  useEffect(() => {
    try {
      const isDismissed = localStorage.getItem(NOTICE_KEY);
      if (!isDismissed) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    try {
      localStorage.setItem(NOTICE_KEY, "true");
    } catch {
      // ignore storage errors
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200/90 text-amber-950 text-xs py-1.5 px-3 flex items-center gap-3 overflow-hidden select-none shadow-sm">
      {/* Badge Tetap Sisi Kiri */}
      <div className="flex items-center gap-1.5 shrink-0 bg-amber-100/90 px-2 py-0.5 rounded text-[11px] font-semibold text-amber-900 border border-amber-300/60 z-10">
        <Info className="h-3.5 w-3.5 text-amber-700 shrink-0" />
        <span className="whitespace-nowrap">Info Pemeliharaan</span>
      </div>

      {/* Area Running Text (Marquee) dengan Pause on Hover */}
      <div className="flex-1 overflow-hidden relative group">
        <div className="whitespace-nowrap inline-block animate-marquee group-hover:[animation-play-state:paused] cursor-default">
          <span className="mx-6">
            Mohon maaf atas ketidaknyamanan yang mungkin timbul. Demi meningkatkan kenyamanan dan keamanan ruang kerja Anda, kami menjadwalkan pemeliharaan sistem rutin malam ini pukul <strong className="font-semibold text-amber-900">01:00 – 03:00 WIB</strong>. Seluruh data persiapan pernikahan Anda tetap tersimpan dengan sangat aman. Terima kasih atas pengertian dan kepercayaannya bersama Weddly.
          </span>
          <span className="mx-6 text-amber-800/80">
            &bull; Pemeliharaan Rutin Pukul 01:00 – 03:00 WIB &bull; Data Anda Dijamin Aman &bull;
          </span>
        </div>
      </div>

      {/* Tombol Tutup Tetap Sisi Kanan */}
      <button
        onClick={handleDismiss}
        className="shrink-0 p-1 rounded hover:bg-amber-200/70 text-amber-800 transition-colors z-10"
        title="Tutup pengumuman"
        aria-label="Tutup pengumuman"
      >
        <X className="h-3.5 w-3.5" />
      </button>

      {/* CSS Keyframe Animation Inline */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          display: inline-block;
          animation: marquee 32s linear infinite;
        }
      `}</style>
    </div>
  );
}
